import { render } from "./StatListCard.vue?vue&type=template&id=35f67acc"
import script from "./StatListCard.vue?vue&type=script&lang=js"
export * from "./StatListCard.vue?vue&type=script&lang=js"

import "./StatListCard.vue?vue&type=style&index=0&id=35f67acc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__